import { messagesConstants } from '../constants';

export class MessagesActions {
    static push(type, data) {
        return (dispatch) => {
            dispatch({type: type, payload: data})
        }
    }

    static pushSuccess(str, {time = '30s',position = 'bottom', allowHTML = false} = {}) {
        const data = {type: 'success', data: str, allowHTML, time, position};
        return MessagesActions.push(messagesConstants.ADD_SUCCESS_MESSAGE, data);
    }

    static pushInfo(str, {time = '30s',position = 'bottom', allowHTML = false} = {}) {
        const data = {type: 'info', data: str, allowHTML, time, position};
        return MessagesActions.push(messagesConstants.ADD_INFO_MESSAGE, data);
    }

    static pushError(str, {time = '30s',position = 'bottom', allowHTML = false} = {}) {
        const data = {type: 'error', data: str, allowHTML, time, position}; 
        return MessagesActions.push(messagesConstants.ADD_ERROR_MESSAGE, data);
    }
}




// WEBPACK FOOTER //
// ./src/actions/messages.js